import { getController, apiService as Service } from '@/services/service'

const url = 'persons'

export const personService = {
	...getController<Api.Person, Api.PersonPostInput, Api.PersonUpdateInput>(url),
	phoneNumbersGet: (id: number) =>
		Service.get<Api.Collection<Api.PhoneNumber>>({
			url: `${url}/${id}/phonenumbers?pageSize=25`,
		}),
	permissionsGet: (id: number) =>
		Service.get<Api.Collection<Api.RolePermission>>({
			url: `${url}/${id}/permissions`,
		}),
	accountsGet: (id: number, params?: Record<string, any>) =>
		Service.get<Api.Collection<Api.Account>>({
			url: `${url}/${id}/accounts`,
			params,
		}),
}

export default personService
